import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

interface CategoryTabsProps {
  active: string;
}

export default function CategoryTabs({ active }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
            active === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}